export default __webpack_public_path__ + "static/media/staking-coins-right.b0c4f2c0.svg";